export const SEARCH_PLACEHOLDER = "activation.home.projects.list.search.placeholder";
const NO_PROJECTS_FILTER_TEXT = "activation.home.projects.list.no.projects.filter.text";
